import {
    USER_LOGOUT, FETCH_SELLERS, ADD_SELLER,FETCH_SELLER,DELETE_SELLER,UPDATE_SELLER,
    REMOVE_SELECTED_SELLERS,ADD_SELECTED_SELLERS,CLEAR_SELECTED_SELLERS
} from "actions/actionTypes";
var _ = require('lodash');

const initialState = {data: [], fetched: false, total: 'initial', selectedSellers:[]};
export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_SELLERS:
            console.log(FETCH_SELLERS, action.payload.data);
            return {
                ...state,
                data: action.payload.data,
                total: action.payload.total,
                fetched: true
            }
        case FETCH_SELLER:
           console.log('FETCH_SELLER', state, action.payload.data);
            return {
                ...state,
                data: _.concat(state.data, [action.payload]),
                total: 1,
                fetched: state.fetched
            }
        case UPDATE_SELLER:
            console.log('UPDATE_SELLER', state, action.payload);
            var itemIndex = _.findIndex(state.data, {'_id': action.payload._id});
            return {
                ...state,
                data: [...state.data.slice(0, itemIndex),
                    action.payload,
                    ...state.data.slice(itemIndex + 1)],
                fetched: state.fetched
            }
        case ADD_SELLER:
           // console.log('ADD_SELLER', state, action.payload);

            return {
                ...state,
                data: _.concat(state.data, [action.payload]),
                fetched: state.fetched
            }
        case DELETE_SELLER:
            console.log('DELETE_SELLER', action.payload);
            var itemIndex = _.findIndex(state.data, {'_id': action.payload.SellerID});
            return {
                ...state,
                data: [...state.data.slice(0, itemIndex),
                    ...state.data.slice(itemIndex + 1)],
                fetched: state.fetched
            }
        case ADD_SELECTED_SELLERS:
          //  console.log('ADD_SELECTED_SELLERS', state,  action.payload);
            var selectedSellersToAdd =_.map( action.payload, function (seller) {
                return seller._id;
            });
            var updatedSelectedSellers = _.uniq(state.selectedSellers.concat(selectedSellersToAdd));
            return {
                ...state,
                selectedSellers: updatedSelectedSellers
            }
        case CLEAR_SELECTED_SELLERS:
            console.log('CLEAR_SELECTED_SELLERS', state,  action.payload);
            return {
                ...state,
                selectedSellers: []
            }
        case REMOVE_SELECTED_SELLERS:
            console.log('REMOVE_SELECTED_SELLERS', state,  action.payload);
            var selectedSellersToRemove =_.map( action.payload, function (seller) {
                return seller._id;
            });
            var updatedSelectedSellers =  _.uniq(_.difference(state.selectedSellers, selectedSellersToRemove));
            console.log('updatedSelectedSellers', updatedSelectedSellers);

            return {
                ...state,
                selectedSellers: updatedSelectedSellers,
            }
        case USER_LOGOUT:
            return initialState;
        default:
            return state;
    }
}
// Get record by id
export const getSeller = (state, id) => {
    return state.adminSellers.data.filter(record => record._id === id)[0];
}


